import React, { Component } from 'react'
import { connect } from 'react-redux'
import { changeView } from 'modules/filter_builder/actions'
import { getDriftProperties } from 'api/contacts'
import { Div } from '@driftt/tide-core'

import List from './List'

import './NewTabs.css'

const mapStateToProps = state => {
  return {
    contactProperties: state.__CRM.filterBuilder.contact
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeView: view => {
      dispatch(changeView(view))
    }
  }
}

class ContactProperties extends Component {
  constructor(props) {
    super(props)

    this.state = {
      properties: null
    }
  }

  componentDidMount() {
    this.getDriftProperties()
  }

  getDriftProperties = async () => {
    const { contactProperties: rawProperties } = this.props
    try {
      const { data: driftProps } = await getDriftProperties()

      const customProps = rawProperties.filter(prop => !driftProps.includes(prop.name))
      const filteredDriftProps = rawProperties.filter(prop => driftProps.includes(prop.name))

      this.setState({
        properties: [
          {
            title: 'Drift Attributes',
            properties: filteredDriftProps
          }, {
            title: 'Custom Attributes',
            properties: customProps.filter(prop => prop.status !== 'HIDDEN')
          }]
      })

    } catch(e) {
      console.warn(e)
    }
  }

  render() {
    const { properties} = this.state
    const { onSelectProp } = this.props

    return (
      <Div className="contact-properties--container">
        <Div className="filter-builder--tabs">
          {!!properties && 
            <List
              displayKey="displayName"
              filterKey="name"
              onSelect={onSelectProp}
              helpText={'Attributes created by Drift and attached to a contact either manually or automatically.'}
              properties={properties}
              subEntityType={'contact'}
            />
          }
        </Div>
      </Div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactProperties)
